export default "__VITE_ASSET__DKZkV_KY__"